interface TextareaProps {
  label: string;
  id: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
  error?: string;
}

export function Textarea({
  label,
  id,
  value,
  onChange,
  placeholder,
  rows = 3,
  error,
}: TextareaProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={id} className="field-label block">
        {label}
      </label>
      <textarea
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        className="bg-[var(--color-elevated)] rounded-md text-body-md text-[var(--color-text-primary)] placeholder:text-[var(--color-text-muted)] px-3 py-2.5 w-full focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)] focus:ring-offset-0 resize-none"
      />
      {error && <p className="text-body-xs text-[var(--color-accent)]">{error}</p>}
    </div>
  );
}
